import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { Choice, FilterDefinition } from '@model';
import { RegisterFilter } from '@core/filter.registry';
import { BaseFilterComponent } from '@core/components/base-filter/base-filter.component';

@RegisterFilter
@Component({
    selector: 'app-checkbox-filter-pane',
    templateUrl: './checkbox-filter-pane.component.html',
    standalone: false
})
export class CheckBoxFilterPaneComponent extends BaseFilterComponent implements OnInit, OnChanges {
  @Output()
  value: string;

  @Output()
  valueChanged = new EventEmitter<FilterDefinition>();

  @Input()
  filter: FilterDefinition;

  componentName = 'CheckBoxFilterPaneComponent';

  selection: Choice;

  _label: string;
  isChanged: boolean;
  showSelected = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.filter && this.filter.checkBoxFilter) {
      this.selection = {...this.filter.checkBoxFilter.selection};
    }
    this.isChanged = this.filter.selected && this.filter.selected.length > 0 ? true : false;
    this.setLabel(this.isChanged);
  }

  ngOnChanges() {
    if (this.filter && this.filter.checkBoxFilter) {
      this.selection = this.filter.checkBoxFilter.selection;
    }
    this.isChanged = this.filter.selected && this.filter.selected.length > 0 ? true : false;
    this.setLabel(this.isChanged);
  }

  setLabel(_isChanged: boolean) {
    this.value = this.selection.selected ? this.selection.name : '';
  }

  updateFilter = event => {
    // this.selection.selected = event.checked ? true : false;
    this.value = event.checked ? this.selection.name : '';
    if (event.checked) {
      this.filter = {
        ...this.filter,
        selected: [this.value],
      };
    } else {
        this.filter = {
          ...this.filter,
          selected: []
      };
    }
    this.filter.checkBoxFilter.selected = this.filter.selected;
    this.filter.checkBoxFilter.selection.selected = event.checked;
    this.valueChanged.emit(this.filter);


  };

}
